var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.182 10.2835C20.1712 10.2936 20.1605 10.3039 20.1499 10.3143C20.1582 10.3062 20.1665 10.2981 20.175 10.2901M20.1378 10.3263C17.3649 13.0982 9.95931 20.8967 8.44352 22.5513C8.00364 23.0315 7.61257 23.586 7.31994 24.2297C6.92031 25.1086 6.22855 26.7539 5.84329 28.43C5.6513 29.265 5.51414 30.1958 5.56714 31.0879C5.61927 31.966 5.87083 33.0231 6.6765 33.8396C7.48629 34.6601 8.54512 34.9244 9.4276 34.9848C10.3232 35.046 11.2592 34.9151 12.0987 34.7282C13.7849 34.3527 15.4441 33.6668 16.334 33.2684C16.9914 32.9741 17.5576 32.577 18.0466 32.1295C19.6908 30.6246 24.6409 26.0743 27.4165 23.3C28.3916 22.3255 29.3389 21.3466 30.2628 20.373L30.2667 20.3689C31.3141 19.2646 32.3335 18.1648 33.3288 17.0855C35.7724 14.4359 36.6512 9.90382 33.6503 6.90442C30.6494 3.90503 26.115 4.78338 23.464 7.22567C22.3851 8.21964 21.2858 9.2375 20.182 10.2835M28.9429 16.6247C29.5459 15.979 30.1418 15.3348 30.7329 14.6939C32.3357 12.9559 32.3972 10.6423 31.1538 9.39958C29.9105 8.15685 27.5957 8.21829 25.8569 9.82027C25.2156 10.4111 24.571 11.0067 23.925 11.6094L28.9429 16.6247Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ac3af582.svg";
export { ForwardRef as ReactComponent };